import {ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Input} from '@angular/core';
import {ColumnMode, SortType} from '@almaobservatory/ngx-datatable';
import {Subscription, timer} from 'rxjs';
import {switchMap, tap} from 'rxjs/operators';
import {SearchTableCellService} from '../search-table-cell.service';

const delay = 300;

@Component({
  selector: 'asax-result-table-search-table-cell-asdms',
  templateUrl: './cell-asdms.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CellAsdmsComponent {
  readonly rowHeight = 50;
  readonly headerHeight = 40;

  @Input() numberAsdms: number;
  @Input() datasetId: string;

  rows: any[];

  ColumnMode = ColumnMode;
  SortType = SortType;

  isLoading: boolean;

  private timerSubscription: Subscription;

  constructor(private readonly searchTableCellService: SearchTableCellService,
              private readonly ref: ChangeDetectorRef) {
  }

  fetchAsdms(): void {
    this.timerSubscription = timer(delay).pipe(
      tap(() => this.isLoading = true),
      tap(() => this.ref.markForCheck()),
      switchMap(() =>  this.searchTableCellService.fetchAsdms(this.datasetId)),
      tap(asdms => this.rows = [...asdms.map(asdm => ({asdm}))]),
      tap(() => this.isLoading = false),
      tap(() => this.ref.markForCheck())
    ).subscribe();
  }

  @HostListener('mouseenter')
  private onMouseEnter(): void {
    this.fetchAsdms();
  }

  @HostListener('mouseleave')
  private onMouseLeave(): void {
    this.timerSubscription?.unsubscribe();
  }
}
